import React from "react";
import { Control, useController } from "react-hook-form";

import SimpleMdeReact from "react-simplemde-editor";

type PropTypes = {
  control: Control;
  name: string;
};

function ContentEditor(props: PropTypes) {
  const { field } = useController({
    name: props.name,
    control: props.control,
    defaultValue: "",
    rules: {
      required: "Content value is required",
      minLength: {
        value: 5,
        message: "Content should be at least 5 letters",
      },
    },
  });

  return (
    <>
      <SimpleMdeReact
        className="bg-gray-100 rounded-md overflow-hidden"
        onChange={field.onChange}
        value={field.value}
      />
    </>
  );
}

export default ContentEditor;
